var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ErrorView from './ErrorView';
/**
 * ErrorBoundary 的实现
 * 提供应用内部报错时避免白屏的能力
 * @see https://zh-hans.reactjs.org/docs/error-boundaries.html
 * @see https://git.hypers.com/snippets/17
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            errorInfo: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error, errorInfo: errorInfo });
        var mask = document.querySelector('.loading');
        mask === null || mask === void 0 ? void 0 : mask.parentNode.removeChild(mask);
    };
    ErrorBoundary.prototype.hasError = function () {
        var error = this.state.error;
        return !!error;
    };
    ErrorBoundary.prototype.render = function () {
        if (!this.hasError()) {
            var children = this.props.children;
            return children;
        }
        var fallback = this.props.fallback;
        var _a = this.state, error = _a.error, errorInfo = _a.errorInfo;
        if (!fallback) {
            return React.createElement(ErrorView, { error: error, errorInfo: errorInfo });
        }
        if (typeof fallback !== 'function') {
            return fallback;
        }
        return fallback({ error: error, errorInfo: errorInfo });
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
